//# sourceMappingURL=client.mjs.map
/// <reference types="./client.d.mts" />
import * as $dynamic from "../../../gleam_stdlib/gleam/dynamic.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $unsafe from "../../../redraw/redraw/internal/unsafe.mjs";
import * as $dom from "../../redraw/dom.mjs";
import {
  createRoot as create_root,
  virtualRoot as virtual_root,
  hydrateRoot as hydrate_root,
  render as do_render,
  unmount,
} from "./client.ffi.mjs";

export { create_root, hydrate_root, unmount, virtual_root };

/**
 * Call `render(root)` to display a piece of JSX (“React node”) into the React
 * root’s browser DOM node.
 *
 * [Documentation](https://react.dev/reference/react-dom/client/createRoot#root-render)
 */
export function render(root, child) {
  return do_render(root, child);
}

/**
 * Call `render(root)` to display a piece of JSX (“React node”) into the React
 * root’s browser DOM node.
 *
 * [Documentation](https://react.dev/reference/react-dom/client/createRoot#root-render)
 */
export function render_(root, child, return$) {
  return $unsafe.coerce(
    $redraw.compose(
      child,
      (child) => {
        let children = return$(child);
        let _pipe = do_render(root, children);
        return $unsafe.coerce(_pipe);
      },
    ),
  );
}
